<template>
	<input :type="type" :name="name" :checked="checked" :class="inputClasses" @change="handleChange" />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
	type: {
		type: String,
		default: 'radio',
		validator: (value) => ['radio', 'checkbox'].includes(value)
	},
	name: {
		type: String,
		required: true
	},
	checked: {
		type: Boolean,
		default: false
	},
	rounded: {
		type: Boolean,
		default: false
	}
})

const emit = defineEmits(['change'])

const inputClasses = computed(() => {
	const baseClass = `custom-input custom-input--${props.type}`
	const roundedClass = props.type === 'checkbox' && props.rounded ? 'custom-input--rounded' : ''
	return `${baseClass} ${roundedClass}`.trim()
})

const handleChange = (event) => {
	emit('change', event)
}
</script>

<style scoped>
.custom-input {
	appearance: none;
	width: 18px;
	height: 18px;
	aspect-ratio: 1 / 1;
	border: 1px solid var(--gris-300);
	outline: none;
	cursor: pointer;
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
}

.custom-input:hover {
	border-color: var(--gris-400);
}

.custom-input:focus {
	box-shadow: 0 0 0 3px var(--bleu-100);
}

.custom-input:checked {
	border-color: transparent;
	background-image: url('@/assets/icon/valid_icon_blue.svg');
}

.custom-input--radio:checked {
	background-color: transparent;
}

.custom-input--checkbox:checked {
	background-color: #61BAE0;
	border-radius: 4px;
}

.custom-input--checkbox.custom-input--rounded:checked {
	border-radius: 50%;
}

.custom-input--radio {
	border-radius: 50%;
}

.custom-input--checkbox {
	border-radius: 4px;
}

.custom-input--checkbox.custom-input--rounded {
	border-radius: 50%;
}
</style>